"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Warigaki = {
    elemName: '割書',
    type: 'inline',
    doc: '割書を挿入します。"｜"で区切られた各テキストが行になります。',
    example: '《割書：一行目｜二行目｜三行目》',
    minContentCount: 2,
    maxContentCount: 4,
    textTemplate: "（{{$0.join('／')}}）",
    htmlTemplate: `
	<span {{{$htmlId}}} class="Warigaki {{$classes}}">
		{{#$0}}
		<span class="warigaki-line">{{{.}}}</span>
		{{/$0}}
	</span>
	`,
    xmlTemplate: `
	<span {{{$xmlId}}} type="warigaki" {{{$xmlSubtypes}}}>
		{{#$0}}
		<span>{{{.}}}</span><lb/>
		{{/$0}}
	</span>
	`,
    docxTemplate: `
	<w:r>
        <w:rPr>
          <w:rFonts w:hint="eastAsia"/>
          <w:eastAsianLayout w:combine="1"/>
        </w:rPr>
        <w:t>{{{$$1}}}{{{$$2}}}
        </w:t>
    </w:r>
	`,
    latexTemplate: '{{#$3}} {{#$4}} \\yongyouwari{ {{{$1}}} }{ {{{$2}}} }{ {{{$3}}} }{ {{{$4}}} } {{/$4}} {{^$4}} \\sangyouwari{ {{{$1}}} }{ {{{$2}}} }{ {{{$3}}} } {{/$4}} {{/$3}} {{^$3}}\\sougyou{ {{{$1}}} }{ {{{$2}}} } {{/$3}}'
};
exports.default = Warigaki;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV2FyaWdha2kuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udmVydGVyL2lubGluZV9ydWxlcy9XYXJpZ2FraS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBLE1BQU0sUUFBUSxHQUFtQjtJQUNoQyxRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxRQUFRO0lBQ2QsR0FBRyxFQUFFLGlDQUFpQztJQUN0QyxPQUFPLEVBQUUsa0JBQWtCO0lBQzNCLGVBQWUsRUFBRSxDQUFDO0lBQ2xCLGVBQWUsRUFBRSxDQUFDO0lBQ2xCLFlBQVksRUFBRSxvQkFBb0I7SUFDbEMsWUFBWSxFQUFFOzs7Ozs7RUFNYjtJQUNELFdBQVcsRUFBRTs7Ozs7O0VBTVo7SUFDRCxZQUFZLEVBQUU7Ozs7Ozs7OztFQVNiO0lBQ0QsYUFBYSxFQUFFLGtOQUFrTjtDQUNqTyxDQUFDO0FBRUYsa0JBQWUsUUFBUSxDQUFDIn0=